import Snackbar from '../components/widget/Snackbar.vue'
import Vue from 'vue'

let SnackbarMixin = {
    name: "SnackbarMixin",
    components: { Snackbar },
    templates: '<snackbar ref="Snackbar"></snackbar>',
    methods: {
        showSnackbar(type, msg) {
            this.$refs.Snackbar.SnackbarShow(type, msg)
        }
    }
}

var EosSnackbar = Vue.extend({
    mixins: [SnackbarMixin]
});

var eosSnackbar = new EosSnackbar();

Vue.prototype.$eosSnackbar = eosSnackbar